import _getIterator from 'babel-runtime/core-js/get-iterator';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

import _ from 'lodash';
import LineChart from '@/components/LineChart';
import { getPoints } from '@/api/dashboard/overview';
import { format } from 'date-fns';

export default {
  components: {
    LineChart: LineChart
  },
  data: function data() {
    return {
      loading: true,
      channels: ['MSDK', 'DSP'],
      selectedChannels: ['MSDK'],
      dataSource: []
    };
  },
  mounted: function mounted() {
    this.initData();
  },

  methods: {
    initData: function initData() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getPoints();

              case 2:
                res = _context.sent;

                _this.dataSource = _.get(res, 'data.data.items');
                _this.loading = false;

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  computed: {
    customOptions: function customOptions() {
      var dataSource = this.dataSource,
          selectedChannels = this.selectedChannels;

      var legend = ['pv', 'ir', 'ws', 'gs'];
      var series = [];
      var xAxisData = [];
      legend.forEach(function (s) {
        series.push({
          name: s,
          type: 'line',
          data: [],
          smooth: true
        });
      });

      dataSource.forEach(function (data) {
        if (!selectedChannels.includes(data.cl)) return;
        var date = format(data.date, 'MM/DD') + (' ' + data.hour + ':00');
        if (!xAxisData.includes(date)) xAxisData.push(date);

        var _loop = function _loop(key) {
          var serieIndex = series.findIndex(function (s) {
            return s.name === key;
          });
          var dateIndex = xAxisData.findIndex(function (d) {
            return d === date;
          });
          if (dateIndex === -1) {
            series[serieIndex].data.push(data[key]);
          } else {
            if (series[serieIndex].data[dateIndex]) {
              series[serieIndex].data[dateIndex] += data[key];
            } else {
              series[serieIndex].data[dateIndex] = data[key];
            }
          }
        };

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = _getIterator(legend), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            _loop(key);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      });

      return {
        title: {
          text: '最近30天playable埋点数据'
        },
        legend: {
          data: legend
        },
        xAxis: {
          data: xAxisData
        },
        grid: {
          bottom: '20%'
        },
        dataZoom: [{
          type: 'slider',
          start: 50,
          end: 100
        }, {
          start: 0,
          end: 10,
          handleIcon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
          handleSize: '80%',
          handleStyle: {
            color: '#fff',
            shadowBlur: 3,
            shadowColor: 'rgba(0, 0, 0, 0.6)',
            shadowOffsetX: 2,
            shadowOffsetY: 2
          }
        }],
        series: series
      };
    }
  }
};